
<div v-if="documents && documents.length > 0">
    <d-dms-stamper
        ref      = "stamper"
        @stamped = "onStamped"
    />

    <div class="v-flex">
        <div
            v-if = "verificationDate"
            class="primary mr-1 header-button"
        >
            <v-tooltip
                bottom
            >
                <template v-slot:activator="{ on, attrs }">
                    <a
                        @click = "onMail"
                        v-bind = "attrs"
                        v-on   = "on"
                    >
                        <v-icon size="20" color="white">mdi-email-send-outline</v-icon>
                    </a>
                </template>
                <span>{{  $t('invoice.doc.stamp.send') }}</span>
            </v-tooltip>
        </div>

        <div
            v-if = "verificationDate && admin"
            class="primary header-button"
        >
            <v-tooltip
                bottom
            >
                <template v-slot:activator="{ on, attrs }">
                    <a
                        @click = "onReset"
                        v-bind = "attrs"
                        v-on   = "on"
                    >
                        <v-icon size="20" color="white">mdi-lock-outline</v-icon>
                    </a>
                </template>
                <span>{{  $t('invoice.doc.stamp.reset') }}</span>
            </v-tooltip>
        </div>
    </div>

    <v-menu
        top
        offset-y
        content-class = "white"
        nudge-top     = "10"
        v-model       = "showMenu"
        v-if          = "!verificationDate"
    >
        <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <div
                        v-if = "!verificationDate"
                        class="primary header-button"
                    >
                        <a
                            class  = "dialog-button"
                            @click = "onStamp"
                            v-bind = "attrs"
                            v-on="{ ...tooltip, ...menu }"
                        >
                            <v-icon color="white" size="20">mdi-stamper</v-icon>
                        </a>
                    </div>
                </template>
                <span>{{  $t('invoice.doc.stamp.execute') }}</span>
            </v-tooltip>
        </template>

        <div
            v-if="this.documents && this.documents.length > 1"
            class="document-content"
        >
            <div
                class="document-header primary white--text"
            >
                {{ $t('invoice.doc.header') }}
            </div>

            <v-container class="document-list">
                <div
                    class="document"
                    v-for="(document, index) in documents" :key="index"
                >
                    <v-card outlined :ripple = "false" class=" pb-0">
                        <inc-document-link
                            :document =" document"
                            @click    = "onStampDocument(document)"
                        />
                    </v-card>
                </div>
            </v-container>
        </div>
    </v-menu>
</div>
